 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import MM from '@/components/mm'
 import ALSOBYMICHAELINNES from '@/components/also-by-michael-innes'
 import LOVE_1 from '@/components/love_1'
 import VOL001 from '@/components/vol-001'
 import VOL001AMATTEROFGOBLINS from '@/components/vol-001-a-matter-of-goblins'
 import VOL001WASHEMORTON from '@/components/vol-001-was-he-morton'
 import VOL001DANGERFIELDSDIARY from '@/components/vol-001-dangerfields-diary'
 import VOL001GREYSGHOST from '@/components/vol-001-greys-ghost'
 import VOL001FALSECOLOURS from '@/components/vol-001-false-colours'
 import VOL001THERIBBON from '@/components/vol-001-the-ribbon'
 import VOL001THEEXILE from '@/components/vol-001-the-exile'
 import VOL001ENIGMAJONES from '@/components/vol-001-enigma-jones'
 import VOL001THEHERITAGEPORTRAIT from '@/components/vol-001-the-heritage-portrait'
 import VOL001MURDERONTHE716 from '@/components/vol-001-murder-on-the-716'
 import VOL001AVERYODDCASE from '@/components/vol-001-a-very-odd-case'
 import VOL001THEFOURSEASONS from '@/components/vol-001-the-four-seasons'
 import VOL001HEREISTHENEWS from '@/components/vol-001-here-is-the-news'
 import VOL001BEARSBOX from '@/components/vol-001-bears-box'
 import VOL001TOMDICKANDHARRY from '@/components/vol-001-tom-dick-and-harry'
 import VOL001THELOMBARDBOOKS from '@/components/vol-001-the-lombard-books'
 import VOL001THEMOUSETRAP from '@/components/vol-001-the-mouse-trap'
 import LOVE_2 from '@/components/love_2'
 import VOL002 from '@/components/vol-002'
 import VOL002CHAPTER001 from '@/components/vol-002-chapter-001'
 import ABOUTTHEAUTHOR from '@/components/about-the-author'
 import VOL001COPYRIGHT from '@/components/vol-001-copyright'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/tlu",
 			"name" : "tlu",
 			"component" : TLU
 		},
 		{
 			"path" : "/mm",
 			"name" : "mm",
 			"component" : MM
 		},
 		{
 			"path" : "/also-by-michael-innes",
 			"name" : "also-by-michael-innes",
 			"component" : ALSOBYMICHAELINNES
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/vol-001",
 			"name" : "vol-001",
 			"component" : VOL001
 		},
 		{
 			"path" : "/vol-001-a-matter-of-goblins",
 			"name" : "vol-001-a-matter-of-goblins",
 			"component" : VOL001AMATTEROFGOBLINS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js